export default __webpack_public_path__ + "static/media/learnAJS.bf353fb3.jpg";